<script lang="ts">
	import type { InstallmentOption } from '$lib/server/httpRequests/learn-more.api.js';
	import { setFormatter } from '$lib/services/formatter.js';
	import LearnMoreMainContent from '@components/content/v1.1/LearnMoreMainContent.svelte';
	import { setContext } from 'svelte';

	let { data } = $props();
	setContext('learnMoreData', data.learnMoreData);
	setFormatter(data.culture, data.learnMoreData?.CurrencyCode);
	const installment = (data.learnMoreData?.Options?.find(
		(option) => option.NumberOfInstallments === data.learnMoreData?.SelectedNumberOfInstallments
	) || data.learnMoreData?.Options?.[0]) as InstallmentOption;
</script>

<LearnMoreMainContent
	{installment}
	totalAmount={data.learnMoreData?.TotalAmount || 0}
	strategy={data.learnMoreData?.PlanStrategy}
/>
